import * as React from 'react'
import { appVersion } from '../../model/AppVersion'

import './Header.scss'
import { loggedTopMenuItems, notLoggedTopMenuItems, TopMenuItem } from '../../navigation'
import Logo from '../Logo/Logo'
import { getAuth, isAdmin, isReviewer } from '../../servicesClient'

export const Header = ({ menuItem, selectMenuItem }) => {
  const auth = getAuth()
  let menuItems = auth ? loggedTopMenuItems : notLoggedTopMenuItems

  if (!isAdmin()) {
    menuItems = menuItems.filter((item) => item !== TopMenuItem.Metadata && item !== TopMenuItem.Settings)
  }
  if (!isReviewer()) {
    menuItems = menuItems.filter((item) => item !== TopMenuItem.Tool)
  }
  return (
    <header className="Header">
      <Logo />

      <ul>
        {menuItems.map((menuItemName, i) => (
          <li key={i} onClick={() => selectMenuItem(menuItemName)} className={menuItemName === menuItem ? 'active' : ''}>
            {menuItemName}
          </li>
        ))}
      </ul>

      <div id="headerTitle">
        Question/Answer Service Review Tool
        <br />v{appVersion}
      </div>
    </header>
  )
}
